import { createAsyncThunk, createSlice } from '@reduxjs/toolkit';

import { getClaimDetails } from 'feature/claims/claimSlice';
import { IFileType } from 'types/Claim';
import { DocType } from 'types/Upload';
import { downloadFileThunk } from './downloaderThunk';

export const downloadFile = createAsyncThunk(
	'download/downloadFile',
	downloadFileThunk,
);

const initialState: {
	fileName: string;
	downloadedDocumentBlob: Blob | null;
	documentList: IFileType[];
	docType: DocType | null;
} = {
	fileName: '',
	downloadedDocumentBlob: null,
	documentList: [],
	docType: null,
};

const download = createSlice({
	name: 'download',
	initialState,
	reducers: {
		resetDownloadState: state => {
			return {
				...initialState,
				documentList: state.documentList,
			};
		},
		setDocumentsList: (state, { payload }: { payload: IFileType[] }) => {
			return {
				...state,
				documentList: payload,
			};
		},
		setDocType: (state, { payload }) => {
			return {
				...state,
				docType: payload,
			};
		},
		resetDocumentBlob: state => {
			return {
				...state,
				downloadedDocumentBlob: null,
				fileName: '',
			};
		},
	},
	extraReducers: builder => {
		builder.addCase(getClaimDetails.fulfilled, (state, { payload }) => {
			return {
				...state,
				documentList: payload.attachments.others,
			};
		});
		builder.addCase(downloadFile.fulfilled, (state, { payload }) => {
			return {
				...state,
				downloadedDocumentBlob: payload.blob,
				fileName: payload.fileName,
			};
		});
	},
});

export const {
	resetDownloadState,
	setDocumentsList,
	setDocType,
	resetDocumentBlob,
} = download.actions;
export default download.reducer;
